// extracted by mini-css-extract-plugin
export default {"container":"SeriesDetailsPage_container__MaUB-"};